import React from 'react';
import { ArrowRight, Zap, Globe, Settings } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-background"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Streamline Your Business with
              <span className="gradient-text"> Smart Automation</span>
            </h1>
            <p className="hero-description">
              OnSkip specializes in business process automation, custom automation solutions, 
              and cutting-edge website development to transform your business processes 
              and boost productivity.
            </p>
            <div className="hero-actions">
              <a 
                href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                className="btn btn-primary btn-large"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Started <ArrowRight size={20} />
              </a>
              <button 
                className="btn btn-secondary btn-large"
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              >
                Learn More
              </button>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="floating-cards">
              <div className="floating-card card-1">
                <Zap className="card-icon" />
                <h4>Automation</h4>
                <p>Smart workflows</p>
              </div>
              <div className="floating-card card-2">
                <Settings className="card-icon" />
                <h4>Data Management</h4>
                <p>Automated workflows</p>
              </div>
              <div className="floating-card card-3">
                <Globe className="card-icon" />
                <h4>Web Development</h4>
                <p>Custom solutions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>100+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3>24/7</h3>
              <p>Support Available</p>
            </div>
            <div className="stat-item">
              <h3>99%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
